import { createAuthClient } from 'better-auth/react'
import { adminClient, lastLoginMethodClient } from 'better-auth/client/plugins'
import { ac, roles } from '@harmoni/auth-access'
import { env } from './env'

/** Staff ops auth client — Admin plugin lives here, not in product web (#576). */
export const authClient = createAuthClient({
  baseURL: env.apiUrl,
  basePath: '/v1/auth',
  plugins: [adminClient({ ac, roles }), lastLoginMethodClient()],
})

export const { signIn, signOut } = authClient

export function useSession() {
  return authClient.useSession()
}
